import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    secondary: {
      main: "#9013fe",
      dark: "#9013fe",
      light: "#9013fe",
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        color: "secondary",
      },
    },
    MuiTextField: {
      defaultProps: {
        color: "secondary",
      },
    },
  },
});

export default theme;
